import { IconClock } from "@tabler/icons-react";
import { Text } from "../../../../components/common/typography";

interface Props {
  label: string;
  value: string;
  span2?: boolean;
  /**
   * When set, renders an amber inline annotation under the value showing the
   * pending proposed change. Pass the formatted display string (the caller
   * resolves IDs to names where needed).
   */
  pending?: string | null;
}

export function DisplayField({ label, value, span2 = false, pending }: Props) {
  const showPending = pending !== null && pending !== undefined && pending !== "";
  return (
    <div className={span2 ? "col-span-2 max-md:col-span-full" : ""}>
      <Text variant="bodySmMedium" tone="dark" className="mb-1.5">{label}</Text>
      <div className="rounded-xl border border-borderDefault bg-bgWhite px-4 py-3">
        <Text variant="body" tone="muted">{value}</Text>
      </div>
      {showPending && (
        <div className="mt-1.5 flex items-center gap-1.5 px-1.5">
          <IconClock size={14} className="shrink-0 text-accentAmber" />
          <Text variant="bodyXs" tone="amber" inline>
            Pending: <span className="font-medium">{pending}</span> — awaiting approval
          </Text>
        </div>
      )}
    </div>
  );
}
